import { Link } from "react-router-dom";
import appstore2 from "../../assets/icon/appstore2.png";
import facebook from "../../assets/icon/fb-menu2.png";
import ggplay2 from "../../assets/icon/ggplay2.png";
import instagram from "../../assets/icon/in-menu2.png";
import twitter from "../../assets/icon/twitter.png";
import ImgFooter from "../../assets/images/footer.png";
import "./Footer.scss";
import { ROUTES } from "../../constants/routers";

const Footer = () => {
    return (
        <footer>
            <img src={ImgFooter} className="img-footer" alt="footer" />
            <div className="container" style={{ position: "relative" }}>
                <div className="row">
                    <div className="col-lg-4 col-12">
                        <h2 className="title">THÔNG TIN LIÊN HỆ</h2>
                        <ul className="desc list-unstyled">
                            <li>
                                <p className="fw-bold">CÔNG TY CỔ PHẦN TẬP ĐOÀN CÔNG NGHỆ HTP</p>
                            </li>
                            <li>
                                <p className="fw-bold">CỔNG THANH TOÁN / VÍ ĐIỆN TỬ HPAY</p>
                            </li>
                            <li>
                                <p>Hotline: 1900 0128</p>
                            </li>
                            <li>
                                <p>Địa chỉ: Số A7 Lô A, Khu 5.2 ha, dự án nhà ở cho cán bộ cao cấp và cán bộ của Ban
                                    Đảng Trung Ương, Phường Yên Hòa, Thành phố Hà Nội, Việt Nam</p>
                            </li>
                        </ul>
                    </div>
                    <div className="col-lg-3 col-6">
                        <h2 className={"title"}>VỀ HPAY</h2>
                        <ul className="desc list-unstyled">
                            <li>
                                <Link to={ROUTES.ABOUT} className="link-hover">
                                    Giới thiệu HPay
                                </Link>
                            </li>
                            <li className="mt-3">
                                <Link to={ROUTES.AGREEMENT} className="link-hover">
                                    Thỏa thuận xử lý dữ liệu cá nhân
                                </Link>
                            </li>
                            <li className="mt-3">
                                <Link to={ROUTES.CONDITION} className="link-hover">
                                    Điều khoản và điều kiện
                                </Link>
                            </li>
                            <li className="mt-3">
                                <Link to={ROUTES.TERM} className="link-hover">
                                    Chính sách bảo mật
                                </Link>
                            </li>
                            <li className="mt-3">
                                <Link to={ROUTES.PRIVACY} className="link-hover">
                                    Quy định về khiếu nại và hoàn tiền
                                </Link>
                            </li>
                            <li className="mt-3">
                                <Link to={ROUTES.SUSPICIOUS_CRITERIA} className="link-hover">
                                    Bộ tiêu chí nhận diện dấu hiệu đáng ngờ
                                </Link>
                            </li>
                        </ul>
                        <div className="mt-3">
                            <img src={facebook} className="me-3" alt="facebook" />
                            <img src={twitter} className="me-3" alt="twitter" />
                            <img src={instagram} alt="instagram" />
                        </div>
                    </div>
                    <div className="col-lg-5 col-6">
                        <h2 className="title">SẢN PHẨM</h2>
                        <ul className="desc list-unstyled">
                            <li>
                                <Link to={ROUTES.E_WALLETS} className="link-hover">
                                    Ví điện tử
                                </Link>
                            </li>
                            <li className="mt-3">
                                <Link to={ROUTES.PAYMENT_GATEWAYS} className="link-hover">
                                    Thanh toán trực tuyến
                                </Link>
                            </li>
                            <li className="mt-3">
                                <Link to={ROUTES.SERVICES} className="link-hover">
                                    Thu hộ
                                </Link>
                            </li>
                            <li className="mt-3">
                                <Link to={ROUTES.FEE_SCHEDULE} className="link-hover">
                                    Biểu phí
                                </Link>
                            </li>
                        </ul>
                        <p className="desc mt-5" style={{ color: "#6B6D6F" }}>
                            Ứng dụng HPay có mặt trên nền tảng Android và iOS
                        </p>
                        <div className="d-flex mt-4 flex-wrap gap-2">
                            <a href="https://apps.apple.com/vn/app/hpay/id6479690061" target="_blank" rel="noreferrer">
                                <img src={appstore2} alt="ios" />
                            </a>
                            <a href="https://play.google.com/store/apps/details?id=com.hpay.ewalletapp" target="_blank" rel="noreferrer">
                                <img src={ggplay2} alt="adr" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
